import type { RawCoordinates } from '@elfsight/widget-map';

const EARTH_RADIUS = 6371;

export const getDistance = (p1?: RawCoordinates, p2?: RawCoordinates) => {
  if (!p1 || !p2) {
    return;
  }

  // use haversine formula to calculate distance between two coordinates
  // https://en.wikipedia.org/wiki/Haversine_formula
  const { lat: lat1, lng: lng1 } = p1;
  const { lat: lat2, lng: lng2 } = p2;

  const degreesToRadians = Math.PI / 180;
  const deltaLat = (lat2 - lat1) * degreesToRadians;
  const deltaLng = (lng2 - lng1) * degreesToRadians;
  const angle =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1 * degreesToRadians) *
      Math.cos(lat2 * degreesToRadians) *
      Math.sin(deltaLng / 2) *
      Math.sin(deltaLng / 2);
  const centralAngle = 2 * Math.atan2(Math.sqrt(angle), Math.sqrt(1 - angle));
  const distance = EARTH_RADIUS * centralAngle;

  return distance;
};
